// extracted by mini-css-extract-plugin
export default {"threatsPage":"Threats_threatsPage__kKWcr","contentGrid":"Threats_contentGrid__GNGNB","trendsAndMatrix":"Threats_trendsAndMatrix__Rpo6x","matrixEmpty":"Threats_matrixEmpty__Dq3V5"};